import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from './pages/AdminLogin.jsx';
import AdminDashboard from './pages/AdminDashboard.jsx';
import SuperadminDashboard from './pages/SuperadminDashboard.jsx';

import TechnicianDashboard from './pages/TechnicianDashboard.jsx';
import { useUserActivity } from './hooks/useUserActivity';
import { AuthContext } from './context/authContext.jsx';
import HomePage from './pages/HomePage.jsx';

function ProtectedRoute({ children, allowedRoles }) {
  const { isAuthenticated, user } = useContext(AuthContext);

  // Validar que el usuario está autenticado
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" />;
  }

  // Validar que el usuario tiene el rol permitido
  if (user && !allowedRoles.includes(user.role)) {
    return <Navigate to="/admin/login" />;
  }

  return children;
}

function App() {
  const { isLoading, isAuthenticated } = useContext(AuthContext);

  // Registrar actividad del usuario solo si está autenticado
  useUserActivity(isAuthenticated);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-bg flex items-center justify-center">
        <div className="text-center">
          <img src="/generic-logo-white.png" alt="Sequela" className="h-16 w-auto mx-auto mb-4" />
          <div className="w-8 h-8 border-4 border-amber border-t-transparent rounded-full animate-spin mx-auto"></div>
          <p className="mt-4 text-content-muted">Cargando...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        {/* Ruta de login */}
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* Rutas protegidas */}
        <Route path="/superadmin/dashboard" element={
          <ProtectedRoute allowedRoles={['superadmin']}>
            <SuperadminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/admin/dashboard" element={
          <ProtectedRoute allowedRoles={['admin', 'operator', 'superadmin']}>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/tecnico/dashboard" element={
          <ProtectedRoute allowedRoles={['technician']}>
            <TechnicianDashboard />
          </ProtectedRoute>
        } />

        {/* Rutas públicas */}
        <Route path="*" element={<HomePage />} />
      </Routes>
    </Router>
  );
}

export default App;
